import { ChevronDownIcon, UploadIcon } from '@100mslive/react-icons';
import {
    Accordion, AccordionActions,
    AccordionDetails,
    AccordionSummary, Box, Button, List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
    TextField
} from '@material-ui/core';
import { Delete, ExpandLess, ExpandMore, UnfoldMore } from '@material-ui/icons';
import { useEffect, useState } from 'react';

export const FileControl = ({ onUpdate, value, onDelete, isSelected }) => {
    const [displayName, setDisplayName] = useState("");
    const [displayTitle, setDisplayTitle] = useState("");
    const [displayPhotoSrc, setDisplayPhotoSrc] = useState("");

    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        try {
            let val = JSON.parse(value);
            setDisplayName(val.displayName);
            setDisplayTitle(val.displayTitle);
            setDisplayPhotoSrc(val.displayPhotoSrc);
        }
        catch {

        }
    }, [value]);

    useEffect(() => {
        setExpanded(isSelected);
    }, [isSelected])

    return (
        <div className='w-full'>
            <Accordion variant='outlined' expanded={expanded}>
                <AccordionSummary
                    className='handle'
                    expandIcon={
                        expanded ?
                            <ExpandLess onClick={() => setExpanded(!expanded)} /> :
                            <ExpandMore onClick={() => setExpanded(!expanded)} />
                    }
                    aria-label="Expand"
                    aria-controls="additional-actions1-content"
                    id="additional-actions1-header"
                    style={{ padding: "0 5px" }}
                >
                    <Box display="flex" alignItems="center" width={"100%"}>
                        <Box display="flex" alignItems="center">
                            <UnfoldMore htmlColor='#CECECE' />&nbsp;
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.1716 7L8.58579 13.5858C7.80474 14.3668 7.80474 15.6332 8.58579 16.4142C9.36684 17.1953 10.6332 17.1953 11.4142 16.4142L17.8284 9.82843C19.3905 8.26633 19.3905 5.73367 17.8284 4.17157C16.2663 2.60948 13.7337 2.60948 12.1716 4.17157L5.75736 10.7574C3.41421 13.1005 3.41421 16.8995 5.75736 19.2426C8.1005 21.5858 11.8995 21.5858 14.2426 19.2426L20.5 13" stroke="#CECECE" stroke-width="1.26316" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </Box>
                        <div className='pl-2 text-gray-500'>
                            File
                        </div>
                    </Box>
                </AccordionSummary>
                <AccordionDetails>
                    <div className='w-full'>
                        <TextField
                            label='Label'
                            onChange={(e) => {
                                setDisplayName(e.target.value);
                                onUpdate(JSON.stringify({
                                    displayName: e.target.value,
                                    displayTitle: displayTitle,
                                    displayPhotoSrc: displayPhotoSrc,
                                }));
                            }}
                            variant='outlined'
                            fullWidth
                            margin='dense'
                            className='my-2'
                            value={displayName}
                        />
                        <TextField
                            label='Title'
                            onChange={(e) => {
                                setDisplayTitle(e.target.value);
                                onUpdate(JSON.stringify({
                                    displayName: displayName,
                                    displayTitle: e.target.value,
                                    displayPhotoSrc: displayPhotoSrc,
                                }));
                            }}
                            variant='outlined'
                            fullWidth
                            margin='dense'
                            className='my-2'
                            value={displayTitle}
                        />
                        <List disablePadding className="border border-color-[#CECECE] p-1 rounded-lg">
                            <ListItem disableGutters>
                                <ListItemText className='pl-2' primary='File type'
                                 secondary={"images/pdf"}
                                    secondaryTypographyProps={{
                                        style: {
                                            fontSize: 12
                                        }
                                    }}
                                />
                                <ListItemSecondaryAction className='pr-0'>
                                    <Button
                                        size='small'
                                        component="label"
                                        style={{ minWidth: "unset", padding: 0, margin: 0 }}
                                    >
                                        <UploadIcon />
                                        <input
                                            hidden
                                            type="file"
                                            name="banner_image"
                                            accept="application/pdf, image/*,video/*"
                                            onChange={(e) => {
                                                var reader = new FileReader();
                                                reader.readAsDataURL(e.target.files[0]);
                                                reader.onload = function () {
                                                    setDisplayPhotoSrc(reader.result);
                                                    onUpdate(JSON.stringify({
                                                        displayName: displayName,
                                                        displayTitle: displayTitle,
                                                        displayPhotoSrc: reader.result,
                                                    }));
                                                };
                                                reader.onerror = function (error) {
                                                    console.log('Error: ', error);
                                                };
                                            }}
                                        />
                                    </Button>

                                </ListItemSecondaryAction>
                            </ListItem>
                        </List>
                    </div>

                </AccordionDetails>
                <AccordionActions>
                    <Button
                        className="ml-0"
                        startIcon={<Delete />}
                        onClick={() => {
                            setExpanded(false);
                            setDisplayName("");
                            setDisplayTitle("");
                            setDisplayPhotoSrc("");
                            onDelete();
                        }} fullWidth
                        variant='contained' color="default">
                        Remove
                    </Button>
                </AccordionActions>
            </Accordion>
        </div>
    )
}
